module.exports = __webpack_public_path__ + "img/img_applicable_04.a7cabf72.png";